export default {
    key: "privacyPolicy",
    basePath: '/privacy-policy',
    exclude: false,
  }
  